import React, { useState } from "react";
import DragCanvas from "./DragCanvas";
import BlockPalette from "./BlockPalette";
import "../../builder/webflow/builder.css";

export default function BuilderEditor({ pageData, onSave }) {
  const [blocks, setBlocks] = useState(pageData?.blocks || []);

  const handleSave = () => {
    onSave(blocks);
    alert("Page saved successfully!");
  };

  return (
    <div className="builder-container">
      {/* Left Palette */}
      <BlockPalette setBlocks={setBlocks} />

      {/* Middle Canvas */}
      <DragCanvas blocks={blocks} setBlocks={setBlocks} />

      {/* Save */}
      <div className="save-area">
        <button className="save-btn" onClick={handleSave}>
          Save Page
        </button>
      </div>
    </div>
  );
}
